export const USER_STATUS = {
  DISABLED: 'DISABLED',
  BLOCKED: 'BLOCKED',
  REJECTED_AUDIT: 'REJECTED_AUDIT'
}
